import { useHistory } from "react-router";

import { MainLayout } from "layouts";
import { DataTable } from "components/DataTable";
import { Button } from "components/Button";
import { TextInput } from "components/TextInput";

import { useReviewsPage } from "./hooks";
import { columns } from "./helpers";

export const ReviewsPage = () => {
  const {
    data,
    pagination,
    search,
    onSearchChanged,
    onRowClick,
    onNextClick,
    onPreviousClick,
    onTableHeaderClick,
  } = useReviewsPage();
  const history = useHistory();

  return (
    <MainLayout
      title="Reviews"
      rightElement={
        <Button
          label="Create new"
          onClick={() => history.push("/reviews/-1")}
        />
      }
    >
      <TextInput
        containerClassName="max-w-sm mb-5"
        type="text"
        name="search"
        placeholder="Search"
        value={search.search}
        onChage={onSearchChanged}
      />
      <DataTable
        columns={columns(onTableHeaderClick)}
        data={data}
        onRowClick={onRowClick}
        pagination={pagination}
        nextClick={onNextClick}
        previousClick={onPreviousClick}
      />
    </MainLayout>
  );
};
